import { useTranslations } from '@vocab/react';
import { Alert, Text } from 'braid-design-system';
import React from 'react';

import type { ErrorMessage } from 'src/types';

import translations from './.vocab';

interface Props {
  error: ErrorMessage;
}

const defaultErrorMessage = 'Something went wrong';

const ServerError = ({ error }: Props) => {
  const { t } = useTranslations(translations);
  const erroMessage = error || defaultErrorMessage;
  return (
    <Alert tone="critical">
      <Text>{t(erroMessage) || t(defaultErrorMessage)}</Text>
    </Alert>
  );
};

export default ServerError;
